import { render, staticRenderFns } from "./CompanyConfigCrud.vue?vue&type=template&id=582fa6d6&"
import script from "./CompanyConfigCrud.vue?vue&type=script&lang=js&"
export * from "./CompanyConfigCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports